import React from "react";
import { JSONPathFinder, Text } from "@merge-api/merge-javascript-shared";
type AdvancedFieldMpapingSelectorProps = {
  jsonString: string;
  handleJsonAdvancedMappingExpressionInput: any;
  jsonFinderClassName?: string;
  fallbackText?: string;
};
const AdvancedFieldMappingSelector = ({
  jsonString,
  handleJsonAdvancedMappingExpressionInput,
  jsonFinderClassName,
  fallbackText,
}: AdvancedFieldMpapingSelectorProps) => {
  // When the full example is unavailable (e.g. decompression failed), render the fallback text
  // (the option's truncated `value` preview) in place of the JSON explorer.
  if (fallbackText) {
    return (
      <div className="max-h-[260px] overflow-scroll rounded-md bg-gray-70 p-[10px]">
        <Text className="text-white">{fallbackText}</Text>
      </div>
    );
  }
  return (
    <div className="max-h-[260px] overflow-scroll !text-white rounded-md [&_pre]:text-white">
      <JSONPathFinder
        className={`${jsonFinderClassName}`}
        jsonData={jsonString}
        onChange={(jsonAdvancedMappingExpression: string | null) => {
          handleJsonAdvancedMappingExpressionInput(jsonAdvancedMappingExpression);
        }}
      />
    </div>
  );
};
export default AdvancedFieldMappingSelector;
